module.exports = __webpack_public_path__ + "img/next.6ef52c6a.svg";